// @ts-nocheck
export default function CTASection() {
  return (
    <>
<section className="cta-sec">
  <canvas id="ctaC"></canvas>
  <div className="cta-ring"></div><div className="cta-ring"></div><div className="cta-ring"></div><div className="cta-ring"></div>
  <div className="cta-con rev">
    <div className="cta-ey">08 / Get started</div>
    <h2 className="cta-h">Get started{" "}<br /><em>in 60 seconds.</em></h2>
    <p className="cta-sub">No credit card. No setup. Or book a 30-minute walkthrough with the team — using a contract you bring.</p>
    <div className="cta-btns">
      <a className="cta-p" data-mag="true" href={`/sign-up`}><span className="cta-p-t">Get started →</span></a>
      <a className="cta-s" href="/book-demo">Book a demo</a>
      <a className="cta-s cta-s-quiet" href="/scan">Free scanner</a>
    </div>
    <p className="cta-note">Already have an account? <a href={`/sign-in`}>Sign in →</a></p>
  </div>
</section>


    </>
  );
}
